import BaseComponent from "../../../../baseComponent.js";

class Parameter extends BaseComponent {
  render() {
    var str = "";
    str += this.props.params.name;
    if (this.props.params.repeatable) {
      str += "...";
    }

    if (this.props.params.optional) {
      str += " - [optional]";
    }

    if (this.props.params.repeatable) {
      str += " repeatable";
    }

    var className = "param";
    if (this.props.focused) {
      className = "param param--active";
    }

    return (
      <div className={className}>
        <div className="function-detail__text-header">{str}</div>
        <div className="function-detail__text-desc">{this.props.params.summary}</div>
      </div>
    );
  }
}

export default class Parameters extends BaseComponent {
  render() {
    var params = [];
    for (var i = 0; i < this.props.function.params.length; i++) {
      params.push(<Parameter
        params={this.props.function.params[i]} key={i} focused={this.props.argIndex == i}/>);
    }

    return (
      <div className="function-detail__parameters">
        {params}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/functions/detail/parameters.jsx